/*
 * @Author: wangyunlin wangyunlin@morewis.com
 * @Date: 2022-10-17 22:25:57
 * @LastEditors: wangyunlin wangyunlin@morewis.com
 * @LastEditTime: 2023-04-06 22:48:20
 * @FilePath: \douyin\src\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

import versionTood from '@/utils/versionUpdate';




const routes = [
    {
        path: '/',
        component: () => import('@/view/index.vue'),
        meta: {title: '快币充值'}
    }, 
    {
      path: '/ks',
      component: () => import('@/view/indexKs.vue'),
      meta: {title: '快币充值'}
  }, 
    {
      path: '/error',
      component: () => import('@/view/error.vue'),
      meta: {title: '快币充值'}
    }, 
    {
        path: '/customerService',
        component: () => import('@/view/customerService.vue'),
        meta: {title: '抖币充值'}
    }, 
    {
        path: '/orderList',
        component: () => import('@/view/orderList.vue'),
        meta: {title: '钻石充值'}
    }, 
    {
        path: '/compDetails',
        component: () => import('@/view/complaint/compDetails.vue'),
        meta: {title: '钻石充值'}
    },
    {
        path: '/compChoose',
        component: () => import('@/view/complaint/compChoose.vue'),
        meta: {title: '钻石充值'}
    },
    {
      path: '/success',
      component: () => import('@/view/success.vue'),
      meta: {title: '支付成功'}
  }, 
]
const router = new Router({
    routes,
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL || '/',
});


// 全局路由守卫
router.beforeEach((to, from, next) => {
  //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  versionTood.isNewVersion()
  next()

  
})



export default router;